import { CSSResultGroup } from 'lit';
import { LitElement, html, property, customElement } from 'lit-element';
import styles from './nile-slide-toggle.css';

@customElement('nile-slide-toggle')
export class NileSlideToggle extends LitElement {
  public static styles: CSSResultGroup = styles;

  @property({ type: String }) label = '';
  @property({ type: Boolean, reflect: true }) isChecked = false;

  toggleValue() {
    this.isChecked = !this.isChecked;
    this.dispatchEvent(
      new CustomEvent('change', { detail: { checked: this.isChecked } })
    );
  }

  public render() {
    return html`
    <div class="nile-slide-toggle">
      <label class="nile-slide-toggle__switch">
        <input
          type="checkbox"
          .checked=${this.isChecked}
          @change=${this.toggleValue}
        />
        <span class="nile-slide-toggle__slider"></span>
      </label>
      <span class="nile-slide-toggle__label"> ${this.label} </span>
    </div>
    `;
  }
}
